import { CompaniesState } from './types';
import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { fetchCompanies, resetCompanies } from './actions';

export const initialState: CompaniesState = {
  data: null,
  loading: false,
  error: null,
};

const loading = createReducer(initialState.loading)
  .handleAction(fetchCompanies.request, () => true)
  .handleAction(fetchCompanies.success, () => false)
  .handleAction(fetchCompanies.failure, () => false)
  .handleAction(resetCompanies, () => false);

const error = createReducer(initialState.error)
  .handleAction(fetchCompanies.success, () => null)
  .handleAction(fetchCompanies.failure, (_state, action) => action.payload.error)
  .handleAction(resetCompanies, () => null);

const data = createReducer(initialState.data)
  .handleAction(fetchCompanies.success, (_state, action) => action.payload.companies ?? [])
  .handleAction(fetchCompanies.failure, () => null)
  .handleAction(resetCompanies, () => null);

export default combineReducers({ loading, error, data });
